import { Component, Input, OnInit } from '@angular/core';

/**
 * permet d'avoir les logotypes de la charte graphique
 * LOGO | title
 * le LOGO est par défaut le secondaire, le primaire peut être choisi
 */
@Component({
  selector: 'p8-layout-settings-logo-title',
  templateUrl: './settings-logo-title.component.html',
  styleUrls: ['./settings-logo-title.component.scss']
})
export class SettingsLogoTitleComponent implements OnInit {
  @Input() title = 'APPLICATION';
  @Input() align: 'start' | 'end' = 'start';
  @Input() logo: 'primary' | 'secondary' = 'secondary';
  /**
   * Couleur du texte de droite, en Hexa RGB
   */
  @Input() color = '#000000';

  constructor() { }

  ngOnInit() {
  }
  logoImage() {
    return this.logo === 'primary' ? './assets/logo-p8-primaire.png' : './assets/logo-p8-secondaire.png';
  }

  /**
   * Avec ngSrc, width ET height sont obligatoires, le width et le height selon le logo pour garder une bonne proportionnalité
   * le primaire est volontairement un peu plus petit à cause du texte en haut et en bas du logo
   */
  height() {
    if (this.logo === 'primary') {
      return '43.58';
    }
    return '35.17';
  }
  width() {
    if (this.logo === 'primary') {
      return '90';
    }
    return '110';
  }
}
